<h2 mat-dialog-title>Datensatz kopieren</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <h3>Bitte den Kopierauftrag bestätigen</h3>
  <form [formGroup]="formGroup">
    @if(showName()) {
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput (keyup)="onKeyUpEvent($event)" formControlName="name">
          @if(showHint()){
          <mat-error>{{hintText()}}</mat-error>
          }
        </mat-form-field>
        <br />
      </div>
    </div>
    }

    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Zugeordneter Konsument (Anwendung)</mat-label>
          <mat-select (valueChange)="changeConsumer($event)" formControlName="consumerId">
            @for (consumer of consumers; track consumer) {
            <mat-option [value]="consumer.id">{{consumer.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if(data.competencyId) {
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Fach/Beruf</mat-label>
          <mat-select [(value)]="data.competencyId" (valueChange)="changeCompetency($event)"
            formControlName="competencyId">
            @for (competency of competencies; track competency) {
            <mat-option [value]="competency.id">{{competency.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Abbruch</button>
  <button mat-raised-button (click)="onSave()" [disabled]="!formGroup.valid">Kopieren</button>
</mat-dialog-actions>